/**
 * Copyright (c) 2022-present TVM Engineering Authors.
 */

export function checkEmptyObject(obj) {
  if (obj === null || obj === undefined) {
    if (obj === "object" && Object.keys(obj).length === 0) {
      return true;
    }
    return true;
  }
}

export function getNameFromEmail(name) {
  return name.indexOf(" (") !== -1 ? name.substr(0, name.indexOf(" (")) : name;
}

export function isValidEmail(emailAddress) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(emailAddress).toLowerCase());
}

export function isValidUsername(value) {
  // if (value >= USER_LENGTH) {
  // const nameFormat = /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{2,}$/;
  const nameFormat = /^[A-Za-z0-9]*$/;
  return nameFormat.test(value);
  // }
}

export function isValidName(value) {
  // if (value >= USER_LENGTH) {
  // const nameFormat = /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{2,}$/;
  const nameFormat = /^[a-zA-Z\s]*$/g;
  return nameFormat.test(value);
  // }
}

export function isValidPassword(value) {
  // Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character @$!%*?&.
  const nameFormat = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
  return nameFormat.test(value);
}

export function isValidPassConfirm(password, confirmPassword, isErrorMessage) {
  let errorFlag = true;
  let passwordErrorMessage = "";

  // if (password.length === 0) {
  // 	errorFlag = false;
  // 	passwordErrorMessage = 'Password is required field';
  // } else if (password.length <= MIN_PASS_LENGTH || password.length >= MAX_PASS_LENGTH) {
  // 	errorFlag = false;
  // 	passwordErrorMessage = 'Password should be min 8 char and max 20 char';
  // } else if (password !== confirmPassword) {
  // 	errorFlag = false;
  // 	passwordErrorMessage = 'Password and confirm password should be same.';
  // }
  //
  // if (confirmPassword.length === 0) {
  // 	errorFlag = false;
  // 	passwordErrorMessage = 'Confirm Password is required field';
  // } else if (confirmPassword.length <= 8 || confirmPassword.length >= 20) {
  // 	errorFlag = false;
  // 	passwordErrorMessage = 'Password should be min 8 char and max 20 char';
  // }

  if (!password) {
    errorFlag = false;
    passwordErrorMessage = "Please enter your password.";
  }

  if (!confirmPassword) {
    errorFlag = false;
    passwordErrorMessage = "Please enter your confirm password.";
  }

  if (typeof password !== "undefined" && typeof confirmPassword !== "undefined") {
    if (password !== confirmPassword) {
      errorFlag = false;
      passwordErrorMessage = "Passwords do not match.";
    }
  }

  return isErrorMessage ? passwordErrorMessage : errorFlag;
}

export function isCompany(value) {
  const nameFormat = /^[a-zA-Z0-9\s]*$/g;
  // const nameFormat = /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{2,}$/;
  return nameFormat.test(value);
}

export function isCountry(value) {
  const nameFormat = /^[a-zA-Z\s]*$/g;
  return nameFormat.test(value);
}

export function isCity(value) {
  const nameFormat = /^[a-zA-Z\s]*$/g;
  // const nameFormat = /^[a-zA-Z',.\s-]{1,25}$/;
  return nameFormat.test(value);
}

export function isZipCode(value) {
  const nameFormat = /^[0-9]{4,}(?:-[0-9]{4})?$/;
  return nameFormat.test(value);
}

export function isValidToolName(value) {
  const pattern = /^[a-zA-Z0-9_. -]+$/;
  const regex = new RegExp(pattern);
  return regex.test(value);
}
